
    import { defineComponent } from 'vue'
    import { iOlapFilter } from '@/modules/documentExecution/olap/Olap'
    import Dropdown from 'primevue/dropdown'
    import Dialog from 'primevue/dialog'

    export default defineComponent({
        components: { Dialog, Dropdown },
        props: { selectedFilter: { type: Object, required: true }, multiHierUN: { type: String, required: true } },
        emits: ['save', 'updateHierarchy', 'setMultiHierUN'],
        data() {
            return {
                member: {} as iOlapFilter,
                selecetedMultiHierUN: '' as any
            }
        },
        watch: {
            selectedFilter() {
                this.loadData()
            }
        },
        created() {
            this.loadData()
        },
        methods: {
            loadData() {
                this.member = this.selectedFilter as iOlapFilter
                this.selecetedMultiHierUN = this.multiHierUN
            }
        }
    })
